import Image from 'next/image';
import { useState } from 'react';

import ThumbnailPlayImage from '../../../../src/images/thumbnail-play.png';
import type { FetchCompanyDetailCompanyFragment } from '../../graphql';
import { CompanyDetailEventModal } from './company-detail-event-modal.component';
import styles from './company-detail-events.component.module.scss';
import { SectionLayout } from './section-layout.component';

type EventItemType = {
  thumbnailUrl: string;
  title: string;
  videoUrl: string;
};

export const EventItem = ({ thumbnailUrl, title, videoUrl }: EventItemType) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  return (
    <div className={styles.eventItem}>
      <button
        aria-label="動画を再生"
        className={styles.playButton}
        type="button"
        onClick={() => setIsOpen(true)}
      >
        <Image
          alt=""
          aria-hidden={true}
          height={52}
          src={ThumbnailPlayImage}
          width={52}
        />
      </button>
      <img
        alt={title}
        className={styles.eventItemThumbnail}
        height={145}
        src={thumbnailUrl}
        width={253}
      />
      <CompanyDetailEventModal
        isOpen={isOpen}
        videoUrl={videoUrl}
        onClose={() => setIsOpen(false)}
      />
    </div>
  );
};

export const CompanyDetailEvents = ({
  videos,
}: {
  videos: FetchCompanyDetailCompanyFragment['publishedPromotionVideos'];
}) => {
  return (
    <SectionLayout heading={{ title: '企業特集動画' }} id="events">
      <div className={styles.eventsBlock}>
        {videos.map((video) => (
          <EventItem
            key={video.id}
            thumbnailUrl={video.image.url}
            title={video.title}
            videoUrl={video.url}
          />
        ))}
      </div>
    </SectionLayout>
  );
};
